import { useEffect } from 'react';
import { useLoginStore } from '@lib/store';
import { useRouteHook } from '@shared/hook';
import { RoutePaths } from '@shared/utils';
import { DUOForm, LoginForm } from './widgets';
import { Contacts } from '@widgets';
import { Logo, Spinner } from '@shared/widgets';
import bgImg from '@assets/images/login-bg.jpg';

export const LoginPage = () => {
  const { navigate } = useRouteHook();

  const { loading, success, data } = useLoginStore();

  useEffect(() => {
    if (loading || !success || !data) return;
    if (data.status === 'locked_out') navigate(RoutePaths.recovery.onNavigate());
  }, [loading, success, data]);

  return (
    <div className='bg-cover bg-center bg-no-repeat' style={{ backgroundImage: `url(${bgImg})` }}>
      <div className='relative mx-auto flex min-h-screen w-full max-w-[300px] flex-col justify-center py-10 text-[#fff]'>
        <Spinner show={loading} />
        {!loading && (
          <div className='flex min-h-[602px] flex-col justify-center'>
            <div className='mx-auto mb-13'>
              <Logo width='210' height='28' />
            </div>
            {data?.status === 'auth' ? <DUOForm devices={data?.devices} token={data?.temp_token} /> : <LoginForm />}
            <Contacts />
          </div>
        )}
      </div>
    </div>
  );
};
